import { useAnimations } from "@react-three/drei";
import { useDracoGLTF } from "../../../../../utils/useDracoGLTF";
import { Suspense, useEffect } from "react";
import { useRemapMaterials } from "../../../Materials";
import { useSpring, animated as a } from "@react-spring/three";
import { useSnapshot } from "valtio";
import { powerrailstore } from "./powerrailstore";
import { UIPortal } from "@solidwhite/ui-portal";
import PowerrailUI from "./PowerrailUI";
import { useSynchronizedState, useMultiuserContext } from "@solidwhite/multiuser";

export const powerrailsData = [
  {
    id: "logistic",
    textId: "L4_CHARGE_APPLICATIONS_POWERRAIL_LOGISTIC",
  },
  {
    id: "amusement",
    textId: "L4_CHARGE_APPLICATIONS_POWERRAIL_AMUSEMENT",
  },
  {
    id: "automotive",
    textId: "L4_CHARGE_APPLICATIONS_POWERRAIL_AUTOMOTIVE",
  },
  {
    id: "airport",
    textId: "L4_CHARGE_APPLICATIONS_POWERRAIL_AIRPORT",
  },
];

const PowerrailApplications = ({ ...props }) => {
  // const { currentRail } = useSnapshot(powerrailstore);
  const [currentRail, setCurrentRail] = useSynchronizedState("c_powerrail", 0);

  useEffect(() => {
    setCurrentRail(0);
    // powerrailstore.currentRail = 0;
    return () => {
      setCurrentRail(0);
      // powerrailstore.currentRail = 0;
    };
  }, []);

  return (
    <group>
      <PowerRailRig>
        <Suspense fallback={null}>
          {powerrailsData.map((pr, i) => (
            <group position={[i * 0, 0, 0]} key={`${pr.id}`}>
              <PowerrailSection model={`Applications_${pr.id}.glb`} active={i == currentRail} />
            </group>
          ))}
        </Suspense>
      </PowerRailRig>

      <UIPortal>
        <PowerrailUI key="Powerrail_UI" />
      </UIPortal>
    </group>
  );
};

const PowerrailSection = ({ model = "", active = false }) => {
  const { scene, animations } = useDracoGLTF(`./models/charge/${model}`);

  const { actions } = useAnimations(animations, scene);

  useRemapMaterials(scene);

  const spring = useSpring({
    from: { scale: 0 },
    scale: active ? 1 : 0,
  });

  useEffect(() => {
    Object.values(actions).forEach((a) => {
      a.timeScale = 0.4;
      a.play();
    });
    // console.log(actions);
  }, [actions]);

  return (
    <a.group scale={spring.scale}>
      <primitive object={scene} />;
    </a.group>
  );
};

const PowerRailRig = ({ children, ...props }) => {
  const [currentRail, setCurrentRail] = useSynchronizedState("c_powerrail", 0);

  const spring = useSpring({
    pos: [-currentRail * 0, 0, 0],
  });

  return <a.group position={spring.pos}>{children}</a.group>;
};

export default PowerrailApplications;
